import { useRef } from 'react'
import classNames from 'classnames'
import { useBoolean, useOnClickOutside } from 'usehooks-ts'
import NoneAnchor from '../../../components/NoneAnchor'
import LoungeBoardNoticeLayer from './LoungeBoardNoticeLayer'
import LoungeBoardNoticeTitle from './LoungeBoardNoticeTitle'

const LoungeBoardNotice = () => {
  const ref = useRef()
  const { value: isOpen, setFalse: close, toggle } = useBoolean(false)
  useOnClickOutside(ref, close)
  return (
    <li className={classNames('open', { on: isOpen })} ref={ref}>
      <NoneAnchor
        className="link_gnb"
        onClick={e => {
          e.preventDefault()
          toggle()
        }}>
        <LoungeBoardNoticeTitle />
        <span className="screen_out">{isOpen ? '닫기' : '열기'}</span>
      </NoneAnchor>
      {isOpen && <LoungeBoardNoticeLayer onClose={close} />}
    </li>
  )
}
export default LoungeBoardNotice
